<template>
  <VAppLayout>
    <VContainer>
      <section
          class="cart">
        <div class="section_title">
          <div class="section_title-content">
            <h3>
              {{ $t('pages.cart.orderHistory') }}
            </h3>
            <span :class="{hidden: computedTableNum === null}">
                          {{ `${$t('pages.cart.table')}: ${computedTableNum}` }}
                        </span>
          </div>
          <div class="section_title-logo">
            <img :src="computedCompanyData.locale.logo" :alt="`Logo of ${computedCompanyData.locale.name}`">
          </div>
        </div>

        <div
            class="cart_list" v-for="order in computedOrders" :key="order.id" >
          <span class="order_title">{{ $t('pages.cart.order') }} #{{order.order_number}} <span class="order_details">({{order.updated_at}}, {{getOrderTotal(order)}})</span></span>
          <div class="cart_list-total">
          </div>
          <ul>
            <li>
              <ul>
                <li
                    v-for="orderItem in order.items"
                    :key="orderItem.id">
                  <p :class="{'subproduct': orderItem.parent_id !== null }">
                    <small>{{ `${getItemQuantity(orderItem)}  x` }}</small> {{ orderItem.product.name }}
                  </p>
                  <em>
                    {{ formatPrice(getItemQuantitySum(orderItem)) }}
                  </em>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="cart_options">
          <VButton type="dark-violet" v-on:click.native="goToCart">
            {{ $t('pages.cart.returnToCart') }}
          </VButton>
        </div>
      </section>
    </VContainer>
  </VAppLayout>
</template>


<script>
// import VCartItem from "@/modules/cart/components/VCartItem.vue";
// import VButton from "@/components/ui/VButton.vue";
import VAppLayout from "@/layouts/VAppLayout.vue";
import VButton from "@/components/ui/VButton.vue";
import VContainer from "@/components/ui/VContainer.vue";

export default {
  name: "History",
  components: {
    VContainer,
    VButton,
    VAppLayout,
    // VButton,
    // VCartItem
  },
  data() {
    return {}
  },
  mounted() {
    this.$store.dispatch('cartStore/FETCH_ORDERS_HISTORY', this.$store)

  },
  computed: {
    computedTableNum: function () {
      return this.$store.getters['getTableName']
    },
    computedCompanyData: function () {
      return this.$store.getters['getCompanyData']
    },
    computedOrders: function () {
        return this.$store.getters["cartStore/getHistory"];
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    },
    getItemQuantity(orderItem) {
      return orderItem.quantity ? orderItem.quantity : orderItem.count
    },
    getItemQuantitySum(orderItem) {
      return orderItem.amount ? orderItem.amount : orderItem.count * orderItem.product.price;
    },
    getOrderTotal(order) {
      // var total = 0;
      // order.items.forEach(item => {
      //   total = total + parseFloat(item.amount);
      // });
      return this.formatPrice(order.sum)
    },
    goToCart() {
      this.$router.push({name: 'bill'})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

ul, li, h6 {
  margin: 0;
  padding: 0;
  list-style: none;
}

.cart {
  box-sizing: border-box;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
  min-height: 100%;
}

.section_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  &-content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    & > h3 {
      font-size: 24px;
      font-weight: 700;
      margin: 0;
      padding: 0;
    }

    & > span {

      font: {
        size: 14px;
        weight: 500;
      };
      color: #929292;

      &:is(.hidden) {
        visibility: hidden;
      }
    }
  }

  &-logo {
    width: 100px;
    height: 60px;
    overflow: hidden;
    flex-shrink: 0;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}


.cart_plug {
  //padding: 22px 14px;
  //background-color: #F5F5F5;
  //border: 2px solid #E6E6E6;
  //border-radius: 20px;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  //min-height: 150px;
  text-align: center;
  height: 100%;
  padding-top: 25%;

  .empty-cart-title {
    padding: 10% 0 5% 0;
    font-size: 1.5rem;
    color: black;
  }

  .empty-cart-message {
    //color: black;
  }
}

.cart_list {
  //display: flex;
  //flex-direction: column;
  //border: 2px solid #E6E6E6;
  //padding: 22px 12px;
  //gap: 12px;
  //border-radius: 40px 40px 0 0;
  //box-shadow: 0 4px 30px 0 #0000001A;

  display: flex;
  flex-direction: column;
  border: 2px solid #E6E6E6;
  padding: 22px 22px;
  gap: 12px;
  border-radius: 12px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.1019607843);

  & > ul {
    display: flex;
    flex-direction: column;
    gap: 30px;

    li {
      width: 100%;

      p.subproduct {
        padding-left: 20px;
      }

      & > span {
        display: block;
        text-align: center;
        font: {
          weight: 700;
          size: 16px;
        };
        color: $color_black;
      }

      & > ul {
        display: flex;
        flex-direction: column;
        gap: 12px;

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            margin: 0;

            small {
              color: #7019FD;
              font-size: 14px;
              font-weight: 500;
            }

          }

          em {
            color: $color_black;
            font: {
              size: 14px;
              style: normal;
              weight: 700;
            }
          }
        }
      }
    }
  }

  .cart_list-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #E6E6E6;
    padding-top: 22px;
    color: $color_black;

    span {
      font: {
        weight: 700;
        size: 16px;
      }
    }
  }
}


.cart_options {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: auto;

  .btn {
    height: 50px !important;
  }

  &.default_button {
    color: #6466f1;
    text-decoration: underline;
    font-size: 1.2em;
    text-align: center;
  }
}

.order_title {
  font-size:18px;
  line-height: 1.1;
  color: black;

  .order_details {
    font-size: 14px;
    color: #6466f1;
  }
}

</style>
